<template>
  <div class="lad-itinerary-section--day">
    <LadItinerarySlider
      v-if="day.images.length"
      :items="day.images"
      :title="title"
      class="image-with-background"
    />

    <LadItinerarySectionTimes
      :times="day.times"
      :show-locations="showTimesLocation"
      :index="index"
      :days-number="daysNumber"
      @collapsed="toggleCollapse"
      @location="handleChangeLocation"
    />

    <LadItinerarySectionMap
      v-if="showMap && !isPpcv1 && (hasMainLocation || hasTimesLocations)"
      :day="day"
      :center="mapCenter"
    />
  </div>
</template>

<script>
import { hydrateWhenVisible } from 'vue-lazy-hydration'

export default {
  name: 'LadItinerarySectionDay',
  components: {
    LadItinerarySlider: hydrateWhenVisible(
      () =>
        import(
          /* webpackChunkName: "lad-itinerary-slider" */ '@/components/frontends/Slider/index'
        ),
      { observerOptions: { rootMargin: '100px' } }
    ),
    LadItinerarySectionTimes: hydrateWhenVisible(
      () => import(/* webpackChunkName: "lad-itinerary-times" */ './times'),
      { observerOptions: { rootMargin: '100px' } }
    ),
    LadItinerarySectionMap: () =>
      import(/* webpackChunkName: "lad-itinerary-map" */ './map'),
  },
  props: {
    day: { type: Object, required: true },
    index: { type: Number, required: true, default: 0 },
    daysNumber: { type: Number, required: true, default: 0 },
    title: { type: String, required: true, default: '' },
  },
  data() {
    return {
      showMap: this.daysNumber <= 1,
      mapCenter: '',
    }
  },
  computed: {
    isPpcv1() {
      return this.$route.params.test === 'ppcv1'
    },
    hasMainLocation() {
      return !!this.day.location
    },
    hasTimesLocations() {
      return this.day.times.some((time) => time.location)
    },
    showTimesLocation() {
      return !this.hasMainLocation && this.hasTimesLocations
    },
  },
  methods: {
    toggleCollapse(show) {
      if (this.hasMainLocation || this.hasTimesLocations) {
        this.showMap = show
      }
    },
    handleChangeLocation(location) {
      this.mapCenter = `${location.lng},${location.lat}`
    },
  },
}
</script>

<style lang="scss">
.lad-itinerary-section--day {
  .lad-slider {
    .swiper-slide {
      &,
      img {
        min-height: 300px;
        max-height: 300px;

        @media (min-width: 768px) {
          min-height: 500px;
          max-height: 500px;
        }
      }

      img {
        object-fit: cover;
      }
    }
  }
}
</style>
